/*
 * @Description: 品牌选择列表
 * @Author: yy
 * @Date: 2019-05-27 14:25:50
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-12-04 15:19:00
 */

import React from 'react';
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { debounce } from 'lodash'
import { getBrandName, IconUrl } from '../../../../controller';
import s from './BrandInput.css';
import cx from 'classnames';
import { Input } from '../FormElement';

class BrandInput extends React.Component {
  static defaultProps = {
    className: ''
  }

  static PropTypes = {
    defaultValue: PropTypes.string,
    onChange: PropTypes.func
  }

  constructor(props){
    super(props)
    this.state={
      value: '',
      list: [],
      current: 0
    }
  }

  componentDidUpdate (props) {
    if (props.value !== this.props.value) {
      this.setState({
        value: this.props.value
      })      
    }
  }

  /**
   * 输入框改变
   * @param {*} e 
   */
  changeHandle = (e) => {
    const value = e.target.value
    this.setState({
      value: value
    })

    this.getBrandName(value)
  }

  /**
   * 从服务的获取品牌列表
   * @memberof BrandInput
   */
  getBrandName = debounce((value) => {
    if (value == '') return false

    getBrandName({q: value})
      .then(res => {
        let _res = res
        if (typeof res === 'string') {
          _res = JSON.parse(res)
        }

        this.setState({
          list: _res.items,
          current: 0
        })
      })
  }, 300)

  /**
   * 点击列表选择品牌
   * @param {Number} index 
   */
  selectHandle = (index) => {
    const list = this.state.list
    const { onChange } = this.props

    if (list.length < 1) return false

    let value = list[index].name

    this.setState({
      value: value,
      list: []
    })

    onChange && onChange(list[index])
  }

  /**
   * 上键事件
   * @param {*} e 
   */
  keyUp = (e) => {
    e.preventDefault()
    const {current, list} = this.state
    this.setState({
      current: current > 0 ? current - 1 : list.length - 1
    })
  }

  /**
   * 下键事件
   * @param {*} e 
   */
  keyDown = (e) => {
    e.preventDefault()
    const {current, list} = this.state
    this.setState({
      current: (current + 1) % list.length
    })
  }

  /**
   * 点击回车事件
   * @param {*} e 
   */
  keySubmit = (e) => {
    e.preventDefault()
    const {current} = this.state
    this.selectHandle(current)
  }

  /**
   * 键盘事件
   * @param {*} e 
   */
  keyHandle = (e) => {
    switch (e.keyCode) {
      case 38:
        this.keyUp(e)
        break
      case 40:
        this.keyDown(e)
        break
      case 13: 
        this.keySubmit(e)
        break
      default:
    }
  }

  renderList = (list) => {
    const current = this.state.current
    return (
      <ul className={s.brandList}>
        {list.map((item, index) => 
          <li className={cx(s.brandItem, {
            [s.isActive]: index === current
          })} key={index} onClick={() => this.selectHandle(index)}>
            <img className={s.brandIcon} src={IconUrl(item.id)} alt=""/>
            <span className={s.brandTitle}> {item.name} </span>
          </li>
        )}
      </ul>
    )
  }

  render() {
    const {value, list} = this.state
    return(
      <div>
        <Input
          type="text"
          placeholder="请输入品牌..."
          value={value}
          onChange={this.changeHandle}
          onKeyDown={this.keyHandle}
        />

        { list.length > 0 ? this.renderList(list) : null}
      </div>
    )
  }
}

export default withStyles(s)(BrandInput)



// WEBPACK FOOTER //
// src/routes/cms/components/BrandComponent/BrandInput.js